import { randSequence } from '@ngneat/falso';

export function MockHawb() { return randSequence({ size: 10, chars: '1234567890' })};
